import React, { useCallback, useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap"
import api from "services/api"
import SimpleHeader from "components/Headers/SimpleHeader.js"
import Loading from "components/Modals/Loading"

const PermissionsPage = () => {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)
  const [savingIds, setSavingIds] = useState([])
  const [search, setSearch] = useState("")

  const fetchCustomers = useCallback(async () => {
    setLoading(true)
    try {
      const response = await api.get("customer/all")
      setCustomers(response.data)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchCustomers()
  }, [fetchCustomers])

  const toggleSmartChatAccess = async (customer) => {
    const nextValue = !customer.smartChatAccess

    setSavingIds((prev) => [...prev, customer._id])
    setCustomers((prev) =>
      prev.map((c) =>
        c._id === customer._id ? { ...c, smartChatAccess: nextValue } : c
      )
    )

    try {
      await api.put("customer/update/" + customer._id, {
        smartChatAccess: nextValue,
      })
    } catch (error) {
      setCustomers((prev) =>
        prev.map((c) =>
          c._id === customer._id
            ? { ...c, smartChatAccess: !nextValue }
            : c
        )
      )
    } finally {
      setSavingIds((prev) => prev.filter((id) => id !== customer._id))
    }
  }

  const normalizedSearch = search.trim().toLowerCase()

  const sortedCustomers = [...customers]
    .filter((customer) => {
      if (!normalizedSearch) return true
      return (
        (customer.shortName || "").toLowerCase().includes(normalizedSearch) ||
        (customer.fullName || "").toLowerCase().includes(normalizedSearch)
      )
    })
    .sort((a, b) =>
      (a.shortName || "").localeCompare(b.shortName || "", "pt-BR", {
        sensitivity: "base",
      })
    )

  return (
    <>
      <SimpleHeader
        name="Permissão ao SmartChat"
        items={[{ level: "nav", name: "Acesso ao SmartChat" }]}
      />
      <Container className="mt--6" fluid>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="8">
                    <h5 className="h3 mb-0">Acesso ao SmartChat por empresa</h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                      Ao ligar o acesso de uma empresa, todos os usuários vinculados a ela
                      passam a ter acesso ao SmartChat no próximo login.
                    </p>
                  </Col>
                  <Col md="4">
                    <Input
                      type="text"
                      placeholder="Pesquisar cliente..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  {sortedCustomers.map((customer) => (
                    <Col md="6" lg="4" key={customer._id} className="mb-4">
                      <Card className="shadow-sm border mb-0">
                        <CardBody className="d-flex align-items-center justify-content-between">
                          <div>
                            <h6 className="mb-1">{customer.shortName}</h6>
                            <p
                              className="text-muted mb-0"
                              style={{ fontSize: "0.8rem" }}
                            >
                              {customer.fullName}
                            </p>
                          </div>
                          <label className="custom-toggle mr-1">
                            <input
                              checked={Boolean(customer.smartChatAccess)}
                              type="checkbox"
                              disabled={savingIds.includes(customer._id)}
                              onChange={() => toggleSmartChatAccess(customer)}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="Não"
                              data-label-on="Sim"
                            />
                          </label>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                  {!loading && sortedCustomers.length === 0 && (
                    <Col xs="12">
                      <p className="text-muted text-center mb-0 py-4">
                        Nenhuma empresa encontrada.
                      </p>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Loading modalOpened={loading} />
    </>
  )
}

export default PermissionsPage
